<template>
  <div v-if="isLoading" class="yf-page-loader">
    <div class="yf-page-loader__inner">
      <img
        src="/static/img/yagifriends/yagifriendslogo.png"
        alt="YagiFriends"
        class="yf-page-loader__logo"
      />
      <div class="yf-page-loader__dots">
        <span></span><span></span><span></span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, onUnmounted, ref } from 'vue'
import { useRouter } from 'vue-router/composables'

const YAGIFRIENDS_PATH_PREFIX = '/yagifriends'

const router = useRouter()

/** 直リンクで /yagifriends に入ってきたときの初回ローディング */
const isInitialLoading = ref(
  window.location.pathname.startsWith(YAGIFRIENDS_PATH_PREFIX)
)
/** /yagifriends への出入りの遷移中 */
const isNavigating = ref(false)

const isLoading = computed(() => isInitialLoading.value || isNavigating.value)

const removeBeforeEach = router.beforeEach((to, from, next) => {
  if (
    to.path.startsWith(YAGIFRIENDS_PATH_PREFIX) ||
    from.path.startsWith(YAGIFRIENDS_PATH_PREFIX)
  ) {
    isNavigating.value = true
  }
  next()
})

const removeAfterEach = router.afterEach(() => {
  nextTick(() => {
    isNavigating.value = false
    isInitialLoading.value = false
  })
})

onUnmounted(() => {
  removeBeforeEach()
  removeAfterEach()
})
</script>

<style lang="scss" scoped>
.yf-page-loader {
  position: fixed;
  inset: 0;
  background: #c2f2c8;
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
}

.yf-page-loader__inner {
  text-align: center;
}

.yf-page-loader__logo {
  height: 36px;
  width: auto;
  display: block;
  margin: 0 auto 20px;
}

.yf-page-loader__dots {
  display: flex;
  gap: 8px;
  justify-content: center;

  span {
    width: 8px;
    height: 8px;
    background: #0f9934;
    border-radius: 50%;
    animation: yf-dot-bounce 1.4s ease-in-out infinite;

    &:nth-child(1) {
      animation-delay: 0s;
    }

    &:nth-child(2) {
      animation-delay: 0.2s;
    }

    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }
}

@keyframes yf-dot-bounce {
  0%,
  80%,
  100% {
    transform: scale(0.6);
    opacity: 0.4;
  }

  40% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
